import React from 'react';
import { 
  RadarChart, 
  PolarGrid, 
  PolarAngleAxis, 
  PolarRadiusAxis, 
  Radar, 
  Tooltip, 
  Legend, 
  ResponsiveContainer 
} from 'recharts';

const AlumniEngagementChart = ({ alumni }) => {
  // Process alumni data for the chart
  const processData = () => {
    if (!alumni || alumni.length === 0) {
      return [];
    }

    // Get campaigns and contacts data
    const campaigns = JSON.parse(localStorage.getItem('campaigns')) || [];
    const allCampaignContacts = [];
    
    campaigns.forEach(campaign => {
      const contacts = JSON.parse(localStorage.getItem(`campaign_contacts_${campaign.id}`)) || [];
      allCampaignContacts.push(...contacts);
    });
    
    // Calculate engagement metrics
    const totalAlumni = alumni.length;
    const linkedInConnected = alumni.filter(a => a.linkedInUrl && a.linkedInUrl.trim() !== '').length;
    const contactedAlumni = new Set(allCampaignContacts.map(c => c.id)).size;
    const respondedAlumni = new Set(allCampaignContacts.filter(
      c => c.status === 'responded' || c.status === 'converted'
    ).map(c => c.id)).size;
    
    // Calculate executive engagement
    const executiveAlumni = alumni.filter(a => {
      const title = (a.currentTitle || '').toLowerCase();
      return title.includes('ceo') || 
             title.includes('cto') || 
             title.includes('cfo') || 
             title.includes('president') || 
             title.includes('vp') || 
             title.includes('director') || 
             title.includes('chief');
    }).length;
    
    const executiveContacted = allCampaignContacts.filter(c => {
      const alumni = alumni.find(a => a.emp_empcode === c.id);
      if (!alumni) return false;
      
      const title = (alumni.currentTitle || '').toLowerCase();
      return title.includes('ceo') || 
             title.includes('cto') || 
             title.includes('cfo') || 
             title.includes('president') || 
             title.includes('vp') || 
             title.includes('director') || 
             title.includes('chief');
    }).length;
    
    // Calculate percentages
    const linkedInRate = totalAlumni > 0 ? (linkedInConnected / totalAlumni) * 100 : 0;
    const contactRate = totalAlumni > 0 ? (contactedAlumni / totalAlumni) * 100 : 0;
    const responseRate = contactedAlumni > 0 ? (respondedAlumni / contactedAlumni) * 100 : 0;
    const executiveRate = executiveAlumni > 0 ? (executiveContacted / executiveAlumni) * 100 : 0;
    const giftRate = contactedAlumni > 0 ? 
      (new Set(JSON.parse(localStorage.getItem('sendoso_gifts') || '[]')
        .map(g => g.contactId)).size / contactedAlumni) * 100 : 0;
    
    return [
      { metric: 'LinkedIn Connection', value: parseFloat(linkedInRate.toFixed(1)) },
      { metric: 'Contact Rate', value: parseFloat(contactRate.toFixed(1)) },
      { metric: 'Response Rate', value: parseFloat(responseRate.toFixed(1)) },
      { metric: 'Executive Engagement', value: parseFloat(executiveRate.toFixed(1)) },
      { metric: 'Gift Engagement', value: parseFloat(giftRate.toFixed(1)) }
    ];
  };

  const data = processData();

  return (
    <div className="h-96">
      <ResponsiveContainer width="100%" height="100%">
        <RadarChart cx="50%" cy="50%" outerRadius="80%" data={data}>
          <PolarGrid />
          <PolarAngleAxis dataKey="metric" />
          <PolarRadiusAxis angle={30} domain={[0, 100]} />
          <Radar
            name="Engagement Rate (%)"
            dataKey="value"
            stroke="#3182CE"
            fill="#3182CE"
            fillOpacity={0.6}
          />
          <Tooltip formatter={(value) => `${value}%`} />
          <Legend />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default AlumniEngagementChart;
